<div class="test-temp-page">
  <h1>Test page</h1>
  <p>This is a temporary test page in wa-account-v2.</p>
  <a routerLink="/login">Back to sign-in</a>
</div>
